var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modalview",
            title: "View Details",
            "cancel-variant": "secondary",
            "ok-title": "Ok",
            "cancel-title": "Close",
            centered: "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return undefined
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showViewModal,
            callback: function ($$v) {
              _vm.showViewModal = $$v
            },
            expression: "showViewModal",
          },
        },
        [
          _vm.selectedItem
            ? _c("div", [
                _c("p", [
                  _c("strong", [_vm._v("Employee Name:")]),
                  _vm._v(" " + _vm._s(_vm.selectedItem.employeeName)),
                ]),
                _c("p", [
                  _c("strong", [_vm._v("Status:")]),
                  _vm._v(" " + _vm._s(_vm.selectedItem.status)),
                ]),
                _c("p", [
                  _c("strong", [_vm._v("Allocation Type:")]),
                  _vm._v(" " + _vm._s(_vm.selectedItem.allocationType) + " "),
                ]),
                _c("p", [
                  _c("strong", [_vm._v("Category:")]),
                  _vm._v(" " + _vm._s(_vm.selectedItem.category)),
                ]),
                _c("p", [
                  _c("strong", [_vm._v("Amount:")]),
                  _vm._v(" Rs " + _vm._s(_vm.selectedItem.amount)),
                ]),
                _c("p", [
                  _c("strong", [_vm._v("Notes:")]),
                  _vm._v(" " + _vm._s(_vm.selectedItem.notes)),
                ]),
                _c("p", [
                  _c("strong", [_vm._v("Is Recurring:")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.selectedItem.isRecurring == true ? "Yes" : "No"
                      ) +
                      " "
                  ),
                ]),
                _c("p", [
                  _c("strong", [_vm._v("Allocation Date:")]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.formatDate(_vm.selectedItem.allocationDate)) +
                      " "
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "editModal",
            title: "Edit Allocation",
            centered: "",
            "hide-footer": "",
          },
          model: {
            value: _vm.showEditModal,
            callback: function ($$v) {
              _vm.showEditModal = $$v
            },
            expression: "showEditModal",
          },
        },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.editAllocation($event)
                },
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Employee Name",
                            "label-for": "employeeNameInput",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { readonly: "", label: "title" },
                            model: {
                              value: _vm.selectedItem.employeeName,
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedItem, "employeeName", $$v)
                              },
                              expression: "selectedItem.employeeName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Status", "label-for": "status" } },
                        [
                          _c("b-form-select", {
                            attrs: {
                              id: "status",
                              options: _vm.statusOptions,
                              required: "",
                            },
                            model: {
                              value: _vm.selectedItem.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedItem, "status", $$v)
                              },
                              expression: "selectedItem.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Allocation Type",
                            "label-for": "allocationTypeInput",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              id: "allocationTypeInput",
                              options: _vm.typeOptions,
                              required: "",
                            },
                            model: {
                              value: _vm.selectedItem.allocationType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectedItem,
                                  "allocationType",
                                  $$v
                                )
                              },
                              expression: "selectedItem.allocationType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Category",
                            "label-for": "categoryInput",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              id: "category",
                              options: _vm.categoryOptions,
                              required: "",
                            },
                            model: {
                              value: _vm.selectedItem.category,
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedItem, "category", $$v)
                              },
                              expression: "selectedItem.category",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Amount", "label-for": "amount" } },
                        [
                          _c("b-form-input", {
                            attrs: { id: "amount", required: "" },
                            model: {
                              value: _vm.selectedItem.amount,
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedItem, "amount", $$v)
                              },
                              expression: "selectedItem.amount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Notes", "label-for": "notes" } },
                        [
                          _c("b-form-input", {
                            attrs: { id: "notes", required: "" },
                            model: {
                              value: _vm.selectedItem.notes,
                              callback: function ($$v) {
                                _vm.$set(_vm.selectedItem, "notes", $$v)
                              },
                              expression: "selectedItem.notes",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Allocation Date",
                            "label-for": "allocationDate",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              id: "allocationDate",
                              value: _vm.formatDate(
                                _vm.selectedItem.allocationDate
                              ),
                              options: _vm.last12Months,
                              required: "",
                            },
                            on: { change: _vm.onDateChange },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { "label-for": "isRecurring" } },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              attrs: { id: "isRecurring" },
                              model: {
                                value: _vm.selectedItem.isRecurring,
                                callback: function ($$v) {
                                  _vm.$set(_vm.selectedItem, "isRecurring", $$v)
                                },
                                expression: "selectedItem.isRecurring",
                              },
                            },
                            [_vm._v(" Is Recurring? ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button", block: "", disabled: _vm.invalid },
                    on: {
                      click: function ($event) {
                        return _vm.editAllocation()
                      },
                    },
                  },
                  [
                    _vm.loading
                      ? _c("b-spinner", {
                          staticClass: "mx-2",
                          attrs: { small: "" },
                        })
                      : _vm._e(),
                    _vm._v("Update "),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    attrs: { type: "button", block: "", disabled: _vm.invalid },
                    on: { click: _vm.closeEditModal },
                  },
                  [_vm._v(" Cancel ")]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.addModal",
                              modifiers: { addModal: true },
                            },
                          ],
                          staticClass: "my-1 mr-2",
                          attrs: { variant: "primary" },
                        },
                        [_vm._v(" Import Allocation ")]
                      ),
                      _vm.HasPermission(_vm.PermissionList.HRMS_Create)
                        ? _c(
                            "b-button",
                            {
                              staticClass: "my-1 mr-2",
                              attrs: {
                                variant: "primary",
                                to: {
                                  path: "/hrmanagement/Allocations/AddAllocation/add-allocation",
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "PlusIcon" },
                              }),
                              _vm._v(" Add Allocation "),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  attrs: {
                    id: "addModal",
                    title: "Import Allocation",
                    "cancel-title": "Close",
                    "hide-footer": "",
                    centered: "",
                  },
                  model: {
                    value: _vm.showAddModal,
                    callback: function ($$v) {
                      _vm.showAddModal = $$v
                    },
                    expression: "showAddModal",
                  },
                },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.ImportAllocation($event)
                        },
                      },
                    },
                    [
                      _c("b-row", [
                        _c(
                          "div",
                          { staticClass: "m-4" },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Upload File",
                                  "label-for": "file-input ",
                                },
                              },
                              [
                                _c("b-form-file", {
                                  attrs: {
                                    id: "file-input",
                                    placeholder:
                                      "Choose a file or drop it here...",
                                    "drop-placeholder": "Drop file here...",
                                  },
                                  model: {
                                    value: _vm.file,
                                    callback: function ($$v) {
                                      _vm.file = $$v
                                    },
                                    expression: "file",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("b-card-text", { staticClass: "my-1" }, [
                              _vm._v(" Selected file: "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.file
                                      ? _vm.file.name
                                      : "No file selected"
                                  )
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-end" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-2",
                              attrs: { variant: "secondary" },
                              on: {
                                click: function ($event) {
                                  return _vm.closemodal()
                                },
                              },
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "b-button",
                            {
                              attrs: { type: "button", variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.ImportAllocation()
                                },
                              },
                            },
                            [_vm._v("Submit")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "my-1",
                      attrs: { cols: "12", md: "2", sm: "9 " },
                    },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end mb-2",
                      staticStyle: { position: "relative", "z-index": "1" },
                      attrs: { cols: "12" },
                    },
                    [
                      _vm.HasPermission(_vm.PermissionList.HRMS_Search)
                        ? _c(
                            "b-button",
                            {
                              attrs: { variant: "outline-danger" },
                              on: { click: _vm.clearFilters },
                            },
                            [_vm._v(" Clear Filters ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                          fields: _vm.fields,
                          items: _vm.filteredAllocations,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          "sort-direction": _vm.sortDirection,
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          filtered: _vm.onFiltered,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "head(employeeName)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort(
                                              "employeeName"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Employee Name")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Filter by Employee Name",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.employeeName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "employeeName",
                                            $$v
                                          )
                                        },
                                        expression: "filters.employeeName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(status)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("status")
                                          },
                                        },
                                      },
                                      [_vm._v("Status")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Filter by Status",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.status,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "status", $$v)
                                        },
                                        expression: "filters.status",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(allocationType)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort(
                                              "allocationType"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Allocation Type")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder:
                                          "Filter by Allocation Type",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.allocationType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "allocationType",
                                            $$v
                                          )
                                        },
                                        expression: "filters.allocationType",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(allocationDate)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort(
                                              "allocationDate"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Allocation Date")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder:
                                          "Filter by Allocation Date",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.allocationDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "allocationDate",
                                            $$v
                                          )
                                        },
                                        expression: "filters.allocationDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(amount)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("amount")
                                          },
                                        },
                                      },
                                      [_vm._v("Amount")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Filter by Amount",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.amount,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "amount", $$v)
                                        },
                                        expression: "filters.amount",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(notes)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("notes")
                                          },
                                        },
                                      },
                                      [_vm._v("Notes")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Filter by Notes",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.notes,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "notes", $$v)
                                        },
                                        expression: "filters.notes",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(index)",
                            fn: function (data) {
                              return [
                                _vm._v(" " + _vm._s(data.index + 1) + " "),
                              ]
                            },
                          },
                          {
                            key: "cell(employeeName)",
                            fn: function (data) {
                              return [_vm._v(" " + _vm._s(data.value) + " ")]
                            },
                          },
                          {
                            key: "cell(status)",
                            fn: function (data) {
                              return [_vm._v(" " + _vm._s(data.value) + " ")]
                            },
                          },
                          {
                            key: "cell(allocationType)",
                            fn: function (data) {
                              return [_vm._v(" " + _vm._s(data.value) + " ")]
                            },
                          },
                          {
                            key: "cell(allocationDate)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " + _vm._s(_vm.formatDate(data.value)) + " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(isRecurring)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " + _vm._s(data.value ? "Yes" : "No") + " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(amount)",
                            fn: function (data) {
                              return [_vm._v(" " + _vm._s(data.value) + " ")]
                            },
                          },
                          {
                            key: "cell(notes)",
                            fn: function (data) {
                              return [_vm._v(" " + _vm._s(data.value) + " ")]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "text-decoration-none",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "text-body align-middle mr-25",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.viewDetails(data.item)
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          staticClass: "mr-50",
                                          attrs: { icon: "EyeIcon" },
                                        }),
                                        _c("span", [_vm._v("View")]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.openEditModal(data.item)
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          staticClass: "mr-50",
                                          attrs: { icon: "EditIcon" },
                                        }),
                                        _c("span", [_vm._v("Edit")]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeAllocation(
                                              data.item.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "TrashIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("Delete")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center mb-1" },
                        [
                          _vm.loading
                            ? _c("b-spinner", {
                                staticStyle: { width: "3rem", height: "3rem" },
                                attrs: {
                                  variant: "success",
                                  label: "Spinning",
                                  block: "",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                      _c("b-form-group", [
                        _vm._v(
                          " Showing " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? _vm.perPage * (_vm.currentPage - 1) + 1
                                : 0
                            ) +
                            " to " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? Math.min(
                                    _vm.perPage * _vm.currentPage,
                                    _vm.totalRows
                                  )
                                : 0
                            ) +
                            " of " +
                            _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                            " entries "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }